import axios from 'axios';

// Dedicated axios instance for the affiliate MARKETER portal. It uses a
// SEPARATE token key (fab_marketer_token) so marketer sessions never collide
// with seller/admin sessions in the same browser.
const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MARKETER_TOKEN_KEY = 'fab_marketer_token';

const marketerApi = axios.create({ baseURL: API_BASE });

marketerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(MARKETER_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

marketerApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem(MARKETER_TOKEN_KEY);
      if (window.location.pathname.startsWith('/affiliate/dashboard')) {
        window.location.href = '/affiliate';
      }
    }
    return Promise.reject(err);
  }
);

export default marketerApi;
